/**
 * Shared constants for the application
 */

/**
 * OpenRouter API base URL
 * Used for all direct API calls to OpenRouter
 */
export const OPENROUTER_API_BASE_URL = 'https://openrouter.ai/api/v1';
